<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="站点列表">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con show">
                        <div class="search-condition">
                            <span class="label">代理商</span>
                            <div class="input-condition">
                                <factor-auto-complete v-model="condition.factor_id" clearable></factor-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="condition.id" :factor-id="condition.factor_id" clearable></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">代理状态</span>
                            <div class="input-condition">
                                <el-select v-model="condition.agent_status">
                                    <el-option value="0" label="全部"></el-option>
                                    <el-option value="1" label="已代理"></el-option>
                                    <el-option value="2" label="未代理"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time" style="min-width: 400px;">
                            <span class="label">代理开始时间</span>
                            <div class="input-condition">
                                <el-date-picker
                                        v-model="condition.time1"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        align="right"
                                        value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                        @change="condition.timestamp = ''"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time" style="min-width: 400px;">
                            <span class="label">代理到期时间</span>
                            <div class="input-condition">
                                <el-date-picker
                                        v-model="condition.time2"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        align="right"
                                        value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                        @change="condition.timestamp = ''"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>
                <div>
                    <div class="clearfix" style="margin-bottom: 5px">
                        <el-button-group class="floatR">
                            <el-tooltip class="item" effect="dark" content="新增站点" placement="top">
                                <el-button  @click="handleAdd()" icon="el-icon-plus" v-permission="'business.sites.add'"></el-button>
                            </el-tooltip>
                        </el-button-group>
                    </div>
                    <el-table
                            :data="list"
                            style="width: 100%"
                            :highlight-current-row="true"
                            stripe
                            tooltip-effect="dark"
                            ref="multipleTable"
                            v-loading="isLoading"
                            header-cell-class-name="table-back"
                            :cell-class-name="cellStatus"
                    >
                        <!--  -->
                        <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
                        <el-table-column  label="ID" prop="id" width="80px"></el-table-column>
                        <el-table-column  label="站点" prop="name">
                             <template slot-scope="scope">
                                 <a style="text-decoration: none;color:#409EFF" :href="'https://'+scope.row.domain_pinyin+'.'+host" target="_blank">{{scope.row.name}}</a>
                            </template>
                        </el-table-column>
                        <el-table-column  label="域名" prop="domain_pinyin"></el-table-column>
                        <el-table-column  label="关联代理商" prop="factor_name"></el-table-column>
                        <el-table-column  label="代理状态" prop="agent_status_text"></el-table-column>
                        <el-table-column  label="是否显示" prop="status" width="80px">
                            <template slot-scope="scope">
                                <el-switch active-color="#13ce66"
                                           v-model="scope.row.status"
                                           active-value='1'
                                           inactive-value='0'
                                           v-permission="'business.sites.status'"
                                           @change="status => change(status,
                                           scope.row)" ></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column  label="代理时间" width="220px">
                            <template slot-scope="scope">
                                <p v-html="scope.row.agent_created_at"></p>
                            </template>
                        </el-table-column>
                        <el-table-column  label="添加人" prop="operator" width="70px"></el-table-column>
                        <el-table-column  label="更新时间" prop="updated_at" width="180px"></el-table-column>
                        <el-table-column  label="创建时间" prop="created_at" width="180px"></el-table-column>
                        <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
                        <el-table-column width="280px"  fixed="right">
                            <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                            <template slot="header" slot-scope="scope">
                                <span style="color: #409EFF">操作</span>
                            </template>
                            <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                            <template slot-scope="scope">
                                <el-button size="mini" @click="openEdit(scope.$index, scope.row)" v-permission="'business.sites.edit'">编辑</el-button>
                                <el-button size="mini" @click.native="openSiteArea(scope.$index, scope.row)" v-permission="'business.site-level'">下级管理</el-button>
                                <el-button size="mini" @click.native="handleLogin(scope.$index, scope.row)" v-permission="'business.sites.list.no_secret_login'">免密登陆</el-button>
                                <!-- <el-dropdown style="margin-left: 10px">
                                    <el-button size="mini">
                                        更多<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="openSiteArea(scope.$index, scope.row)"
                                            v-permission="'business.site-level'">下级管理</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleLogin(scope.$index, scope.row)"
                                            v-permission="'business.sites.list.no_secret_login'">免密登陆</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
                    <template v-if="list.length > 0">
                        <!-- :total="list.length" -->
                        <el-pagination background layout="total,prev, pager, next"  :current-page="condition.page" :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                    </template>
                </div>
        </el-tab-pane>
    </el-tabs>
</div>
</template>
<script>
import add from "./listComponent/add"
import edit from "../agent/listComponent/edit"
import { getSite } from "@/service/site"
import { parseTime } from '@/utils'
import { getSiteLoginPassport } from '@/service/user'
import factorAutoComplete from '@/components/auto-complete/factor-auto-complete'
import SiteAutoComplete from "../../../components/auto-complete/site-auto-complete";
import {editSiteStatus} from "../../../service/site";

export default {
    name: 'SiteList',
    components: {
        SiteAutoComplete,
        add,
        edit,
        factorAutoComplete
    },
    data() {
        return {
            condition: {
                id: '',
                name: '',
                factor_id: '',
                agent_status: '',
                total : 0,
                per_page : 10,
                page : 1,
                time1:[],
                time2:[],
            },
            isShowCheckBox: true, // 是否显示多选框
            isLoading: false, // 是否显示loading加载
            list: [],
            rowData: {},
            sites : [],
            isShowMore: false,
            host:""
        }
    },
    mounted () {
        this.initData()
        const domain=document.domain
        this.host = window.serverConfig[window.siteMap[domain]].VUE_APP_HOST.substring(14)
    },
    methods: {
        /** 初始化数据请求 */
        async initData () {
            let query = this.condition
            query.owned = 1;
            if (this.condition.time1 && this.condition.time1.length > 0) {
                query.sign_start_time_start = new Date(this.condition.time1[0]+'' + ' 00:00:00').getTime()/1000
                query.sign_start_time_end = new Date(this.condition.time1[1]+'' + ' 23:59:59').getTime()/1000
            }
            if (this.condition.time2 && this.condition.time2.length > 0) {
                query.sign_end_time_start = new Date(this.condition.time2[0]+'' + ' 00:00:00').getTime()/1000
                query.sign_end_time_end = new Date(this.condition.time2[1]+'' + ' 23:59:59').getTime()/1000
            }
            this.isLoading = true
            await getSite(query).then((data) => {
                this.condition.total= parseInt(data.total)
                this.condition.per_page = parseInt(data.per_page)
                let listData = data.data
                for (let i in listData) {
                    let row = listData[i]
                    row.status = row.status+"";
                    row.agent_created_at = row.agent_time_str != '' ? row.agent_time_str : ''
                    if (row.days_remaining != '') {
                        row.agent_created_at += "<p style='color: red'>仅剩"+row.days_remaining+"天</p>"
                    }
                }
                this.list = listData
            })
            this.isLoading = false
        },
        handleLogin(index, row) {
            getSiteLoginPassport(row.id).then((data) => {
                let url = data.redirect + '?passport=' + data.passport
                // window.location.href = url
                setTimeout(()=>{
                    window.open(url)
                },100)
            })
        },
        openEdit(index, row) {
            this.$router.push('edit?id=' + row.id);
        },
        handleAdd(){
            this.$router.push('add');
        },
        /** 监听到改变switch */
        change (status, data) {
            let message = '';

            if (status == '0') {
                message = '禁用后，该站点被隐藏，是否确认？'
            } else {
                message = '启用后，该站点将显示，是否确认？'
            }
            this.$confirm(message, '提示').then(_ => {
                let query = {
                    status : status
                };
                editSiteStatus(data.id, query).then((data) => {
                    this.$message({
                        message: '修改成功',
                        type: 'success',
                        duration: 3 * 1000
                    })
                }).catch(err => {
                    this.$message({
                        message: err.message || '修改失败',
                        type: 'error',
                        duration: 3 * 1000
                    })
                })
            }).catch(_ => {
                data.status = status == '1' ? '0' : '1'
            })
        },
        openSiteArea(index, row) {
            this.$router.push('level?id=' + row.id);
        },
        handleSearch() {
            this.condition.page = 1
            this.initData()
        },
        resetSearch() {
            this.condition = {
                id: '',
                name: '',
                factor_id: '',
                agent_status: '',
                total : 0,
                per_page : 10,
                page : 1
            }
            this.initData()
        },
        cellStatus ({row, column, rowIndex, columnIndex}) {
            if (column.property === 'agent_status' && row.agent_status == 1) {
                return 'danger-cell'
            }
        },
        currentChange (index) {
            this.condition.page = index
            this.initData()
        },
    }
}
</script>
